module.exports = __webpack_public_path__ + "img/other-weights.069919e4.svg";